import { api } from "./../api";
import { addQueryParams, getProxyUrl } from "../utils";
import { transformCommitteeName } from "../../utils/transform";
import { mapDocumentToPatchQuery } from "../mappers/document";

export function getDocumentsUrl(committeeId, params) {
  let proxyUrl = getProxyUrl(
    `/Documents/documents/${transformCommitteeName(committeeId)}`,
  );
  proxyUrl = addQueryParams(proxyUrl, params);
  return api.get(proxyUrl);
}

export function getDocumentUrl(uri, config) {
  let proxyUrl = getProxyUrl(`/Documents/document/${uri}`);
  return api.get(proxyUrl, config);
}

export function getDocumentSafeUrl(uri) {
  let getPromise = getDocumentUrl(uri, { tolerate401: true });
  return new Promise((resolve) => {
    getPromise.then(resolve).catch((error) => {
      console.error(`getDocumentSafe error: '${uri}': ${error}`);
      resolve(null);
    });
  });
}

export function deleteDocumentUrl(documentUrl) {
  const proxyUrl = getProxyUrl(`/Documents/document/${encodeURI(documentUrl)}`);
  return api.delete(proxyUrl);
}

export function updateDocumentUrl(document) {
  let proxyUrl = getProxyUrl(`/Documents/document/${encodeURI(document.url)}`);
  proxyUrl = addQueryParams(proxyUrl, mapDocumentToPatchQuery(document));
  return api.patch(proxyUrl, null);
}

export function setDocumentMetadataUrl(committeeId, params, metadata) {
  let proxyUrl = getProxyUrl(
    `/Documents/document/${transformCommitteeName(committeeId)}`,
  );
  proxyUrl = addQueryParams(proxyUrl, params);
  return api.post(proxyUrl, metadata);
}

export function uploadDocumentUrl(data, committee) {
  // Generate a GUID using crypto.randomUUID() or a UUID library
  const guid = crypto.randomUUID
    ? crypto.randomUUID()
    : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16),
      );

  // Extract file extension from data.name if data is a File object
  // or use a default extension
  const extension = data instanceof File ? data.name.split(".").pop() : "bin";

  // Create the filename in the required format
  const filename = `binary-${guid}.${extension}`;

  const transformedCommitteeId = transformCommitteeName(committee);
  const proxyUrl = getProxyUrl(
    `/Document/${filename}/${transformedCommitteeId}`,
  );

  return api.post(proxyUrl, data);
}

export function downloadZipUrl(uris) {
  return api.post(
    "/api/files/zipFiles",
    { uris },
    { responseType: "arraybuffer" },
  );
}

export function getRelatedReferencesUrl(documentId) {
  const proxyUrl = getProxyUrl(`/References/${documentId}`);

  return api.get(proxyUrl);
}
